import { chunk } from 'lodash';
import React from 'react';
import HorizontalCarousel from 'components/molecules/horizontalCarousel';
import { useViewport } from 'components/templates/viewportProvider';
import pdfIconWhite from 'assets/images/pdfIconWhite.png';
import './style.scss';
import { Image } from 'components/atoms/image';
import { PdfButton } from 'components/atoms/pdfButton';

const ProjectAmenitiesMobile = props => {
  const { height } = useViewport();
  const {
    media_path,
    mobile,
    amenity_mobile_image,
    project_amenities,
  } = props.props.data.data;
  const image_path = `${media_path}${mobile}/${amenity_mobile_image}`;
  let amenities = chunk(project_amenities, 9);
  return (
    <div className="project-amenities-mobile-body" style={{ height }}>
      <Image src={image_path} alt={'image-amenities'} />
      <div className="features">
        <div className="main-row">
          <h2 className={'heading'}>Amenities</h2>
          {props.props.data && props.props.data.pdfUrl && (
            <button
              type={'button'}
              className={'download-button'}
              onClick={() => window.open(props.props.data.pdfUrl, '_blank')}
            >
              <img src={pdfIconWhite} alt="pdf icon" />
              <p className={'upper-text'}>DOWNLOAD</p>
              <p className={'lower-text'}>BROCHURE</p>
            </button>
          )}
        </div>
        <HorizontalCarousel
          cssFor={'amenities-carousel-container'}
          type={'property-amenity'}
          data={amenities}
        />
      </div>
    </div>
  );
};
export default ProjectAmenitiesMobile;
